import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConsultaCotizacionService {

    constructor(private apiService: ApiService, private http: HttpClient) { }


    downloadCotizacionFormato1(numint: number, cia: string) {//sin descuento
        const fullUrl = environment.serviceUrl_Report + `cotizacion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        // const fullUrl = environment.serviceUrl + `cotizacion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    downloadDetalleResumenPDF(idres: number) {//sin descuento
        const fullUrl = environment.serviceUrl + `fe-resumen-diario-cab/${idres}/detalle/pdf`;
        // const fullUrl = environment.serviceUrl + `cotizacion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }
 
    downloadCotizacionFormato2(numint: number, cia: string) {//sin descuento
        const fullUrl = environment.serviceUrl_Report + `cotizacion/${numint}/report/public/format-condesc-default.pdf?` + "cia=" + cia;
        // const fullUrl = environment.serviceUrl + `cotizacion/${numint}/report/public/format-default-condesc.pdf?` + "cia=" + cia;
        
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    downloadCotizacionFormatoTicket(numint: number, cia: string) {//sin descuento
        const fullUrl = environment.serviceUrl_Report + `cotizacion/${numint}/report/public/format-ticket-1.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        }; 
        return this.http.get(fullUrl, httpOptions);
    }

    visar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `cotizacion/${numint}/visar?` + "coduser=" + coduser, { observe: 'response' });
    }

    aprobar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `cotizacion/${numint}/aprobar?` + "coduser=" + coduser, { observe: 'response' });
    }

    rechazar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `cotizacion/${numint}/rechazar?` + "coduser=" + coduser, { observe: 'response' });
    }

    anular(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `cotizacion/${numint}/anular?` + "coduser=" + coduser, {}, { observe: 'response' });
    }
    anular_v2(numint: number, comentario: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `cotizacion/${numint}/anular?` + "comentario=" + comentario, {}, { observe: 'response' });
    }

    buscar(fdesde: Date, fhasta: Date, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi('cotizacion/buscar?');
        return this.apiService.execGetQueryJson(`fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`);
    }

    obtener(numint: number,): Observable<any> {
        this.apiService.setUrlPathApi('situacion/');
        return this.apiService.execGetQueryJson(`${numint}`);
    }

    downloadExcelComercialResportesCotizaciones(fdesde: string, fhasta: string,codsuc: number, lugemi: number, codven:number, situac:string , codcli: string, limit: number , offset : number): Observable<any> {
        this.apiService.setUrlPathApi('consultas/cotizaciones');
        return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
      }

}